import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { showError, showSuccess } from "ReduxErrorBar";
import { updateEventGuideFiles, filesChanged } from "ActionsEventguide";
import { uploadContentFile } from "ContentActions";
import { NEW_IMAGE_PATH, BASE_IMAGES_URL } from "Constants";
import AllFilesDrop from "AllFilesDrop";
import LocaleStrings from "Languages";

import { CONTENT_FILE_TYPE_EVENTGUIDE, COMMON_FAIL_MESSAGE } from "Constants";

class EventGuideFileUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      preview: [],
      filesPreview: [],
      filesToBeSent: [],
    };
  }

  onDrop(acceptedFiles, rejectedFiles) {
    var filesToBeSent = acceptedFiles[0];
    var filesPreview = acceptedFiles[0].name;
    var preview = acceptedFiles[0].preview;

    this.setState({ ...this.state, filesToBeSent, filesPreview, preview });

    var fileData = { file: filesToBeSent, filename: filesPreview };
    this.props.uploadContentFile(
      fileData,
      CONTENT_FILE_TYPE_EVENTGUIDE,
      (response) => {}
    );
  }

  onFilesDrop = (index, files) => {
    let { eventguidefilesList } = this.props;

    eventguidefilesList[index].file = files.file ? files.file : "";
    eventguidefilesList[index].filename = files.filename ? files.filename : "";

    this.props.updateEventGuideFiles(eventguidefilesList);
  };

  onFileAvailable = (available) => {
    this.props.filesChanged({ ischanged: available });
  };

  otherFiles = () => {
    let { initialValues, eventguidefilesList } = this.props;

    return _.map(eventguidefilesList, (item, index) => {
      var filePreview = "";
      var fileName = "";
      var fileOld = true;
      if (item && item.file) {
        var file = item.file;
        fileName = item.filename;
        filePreview = `${BASE_IMAGES_URL}/${file}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}&download=true`;
        fileOld = true;
        var n = file.search(";base64,");
        if (n > 0) {
          fileOld = false;
        }
      }

      return (
        <div key={`key-${index}`} style={{ marginBottom: "8px" }}>
          <AllFilesDrop
            width={250}
            height="auto"
            onFileSave={this.onFilesDrop.bind(this, index)}
            filepath={filePreview}
            onFileChnageLocally={this.onFileAvailable}
            fileName={fileName}
            fileOld={fileOld}
            className="content-files-dropbox"
            innerText={
              <div className="content-files-drop-text">
                <div>
                  <img src={`${NEW_IMAGE_PATH}picture.png`} />
                </div>
                <div>
                  {LocaleStrings.drag_and_drop} <br />
                  {LocaleStrings.or}{" "}
                  <span className="select-file">
                    {LocaleStrings.select_file}
                  </span>
                </div>
              </div>
            }
          />
        </div>
      );
    });
  };

  render() {
    var eventguide = this.props.initialValues;
    return (
      <div>
        <div className="dashboard-inside-container">
          <div className="form-group">
            <div className="row">
              <div
                className="col-sm-12"
                style={{ paddingRight: "0px", paddingLeft: "0px" }}
              >
                {this.otherFiles()}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    initialValues: state.eventguide,
    eventguidefilesList: state.eventguidefilesList,

    acceptedFiles: state.acceptedFiles,
    uploadprogress: state.contentFileUploadProgress,
    fileUploadInProcess:
      state.contentFileUploadProgress &&
      state.contentFileUploadProgress >= 0 &&
      state.contentFileUploadProgress < 100,
    uploadFailed: state.contentFileUploadFailed,
  };
}

export default connect(mapStateToProps, {
  uploadContentFile,
  showError,
  showSuccess,
  updateEventGuideFiles,
  filesChanged,
})(EventGuideFileUpload);
